/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicMatchOperationV2Player
 */
export interface PublicMatchOperationV2Player {
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Player
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2Player
     */
    playerNumber?: number | null;
    /**
     * Public display label preserving all given names and shortening each family name to an initial (Given Names S. S.). Absent when structured name boundaries are unavailable. Never includes full family names.
     * @type {string}
     * @memberof PublicMatchOperationV2Player
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the PublicMatchOperationV2Player interface.
 */
export function instanceOfPublicMatchOperationV2Player(value: object): value is PublicMatchOperationV2Player {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2PlayerFromJSON(json: any): PublicMatchOperationV2Player {
    return PublicMatchOperationV2PlayerFromJSONTyped(json, false);
}

export function PublicMatchOperationV2PlayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2Player {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'playerNumber': json['playerNumber'] == null ? undefined : json['playerNumber'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function PublicMatchOperationV2PlayerToJSON(json: any): PublicMatchOperationV2Player {
    return PublicMatchOperationV2PlayerToJSONTyped(json, false);
}

export function PublicMatchOperationV2PlayerToJSONTyped(value?: PublicMatchOperationV2Player | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'playerNumber': value['playerNumber'],
        'displayName': value['displayName'],
    };
}

